import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../environments/environment'
import { JSONRpcResponse } from '../Interfaces/JSONRpcResponse'
import { JSONRpc } from './service-jsonrpc'

@Injectable({
    providedIn: "root",
})
export class CourrierService {
    constructor(private http: HttpClient) { }


    list(options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.courrier:list",
            params: {
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

    html(id: number, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.courrier:html",
            params: {
                id: id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

    htmlMulti(id: number, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.courrier:htmlMulti",
            params: {
                id: id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

    get(id: number, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.courrier:get",
            params: {
                id: id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    
     gets(options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.courrier:gets",
            params: {
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    

    getParamsCourrier(): Observable<any> {
        let rpcMethod = new JSONRpc(
            {
                jsonrpc: "2.0",
                method: "webservice.parametre:courrier",
                params: {
                }
            }
        )
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

    getCourriersType(demandeType: string = 'DOSSIER'): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.courrier:defaut",
            params: {
                options: {
                    demande_type: demandeType
                },
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

    setCourrierEtat(demandedcourrierid: number, etat: number): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.courrier:etat",
            params: {
                id: demandedcourrierid,
                etat: etat,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

    setCourrierRestore(demandecourrierid: number): Observable<JSONRpcResponse> {
        return this.setCourrierEtat(demandecourrierid, 1)
    }

    setCourrierDelete(demandecourrierid: number): Observable<JSONRpcResponse> {
        return this.setCourrierEtat(demandecourrierid, 0)
    }
}
